import { BRAND, BRAND_RADIUS, brandAlpha } from './brandTokens';

const decorationBaseSx = {
  content: '""',
  position: 'fixed',
  zIndex: -1,
  pointerEvents: 'none',
};

/**
 * Full-page brand surface (auth, loading and error screens): flat primary with
 * the brand's arc + pill curves. Children render above the decoration.
 */
export const brandBackdropSx = {
  background: BRAND.primary,
  color: BRAND.onPrimary,
  isolation: 'isolate',
  '&::before': {
    ...decorationBaseSx,
    width: { xs: 420, md: 680 },
    height: { xs: 420, md: 680 },
    borderRadius: '50%',
    border: `1px solid ${BRAND.onPrimaryLine}`,
    right: { xs: -240, md: -220 },
    bottom: { xs: -220, md: -280 },
  },
  '&::after': {
    ...decorationBaseSx,
    width: { xs: 160, md: 260 },
    height: { xs: 80, md: 130 },
    borderRadius: `${BRAND_RADIUS.pill} ${BRAND_RADIUS.pill} 0 0`,
    background: BRAND.accent,
    left: { xs: -30, md: 72 },
    bottom: 0,
  },
};

/** White card that sits on a brand backdrop. */
export const brandCardSx = {
  borderRadius: BRAND_RADIUS.card,
  background: BRAND.surface,
  color: BRAND.text,
  border: `1px solid ${BRAND.line}`,
  boxShadow: `0 24px 48px ${brandAlpha('primaryDark', 0.35)}`,
};
